import styled from 'styled-components';
const Container = styled.div`
    display: flex;
    flex-direction: column;
    h1{
        font-size: 40px!important;
    }
`

export  {Container};